import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=b65fbf4e&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=b65fbf4e&prod&lang=css&"
import style1 from "./coupon.vue?vue&type=style&index=1&id=b65fbf4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65fbf4e",
  null
  
)

export default component.exports